import { useSiteSettings } from "../../../contexts/SiteSettingsContext";
import type { ArticleItem } from "../../../types/settings";
import ImageUploadField from "./ImageUploadField";

export default function ArticlesTab() {
  const { settings, updateSettings } = useSiteSettings();

  const updateItem = (idx: number, patch: Partial<ArticleItem>) => {
    const articles = settings.latestArticles.map((a, i) => (i === idx ? { ...a, ...patch } : a));
    updateSettings({ latestArticles: articles });
  };

  const removeItem = (idx: number) => {
    updateSettings({ latestArticles: settings.latestArticles.filter((_, i) => i !== idx) });
  };

  const addItem = () => {
    const newItem: ArticleItem = {
      href: "https://",
      img: "",
      title: "新しい記事タイトル",
      date: new Date().toISOString().slice(0, 10).replace(/-/g, "."),
    };
    updateSettings({ latestArticles: [...settings.latestArticles, newItem] });
  };

  return (
    <div>
      <h3 className="text-sm font-bold text-gray-700 mb-4 pb-2 border-b border-gray-200">最新記事設定</h3>

      <div className="mb-4">
        <label className="block text-xs font-medium text-gray-600 mb-1">セクションタイトル</label>
        <input
          type="text"
          value={settings.latestArticlesTitle}
          onChange={(e) => updateSettings({ latestArticlesTitle: e.target.value })}
          className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
        />
      </div>

      <div className="space-y-3">
        {settings.latestArticles.map((article, i) => (
          <div key={i} className="border border-gray-200 rounded-lg p-3 space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-gray-500">記事 {i + 1}</span>
              <button
                onClick={() => removeItem(i)}
                className="text-xs text-red-400 hover:text-red-600 cursor-pointer flex items-center gap-1"
              >
                <i className="ri-delete-bin-line" /> 削除
              </button>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-0.5">タイトル</label>
              <input
                type="text"
                value={article.title}
                onChange={(e) => updateItem(i, { title: e.target.value })}
                className="w-full border border-gray-200 rounded px-2 py-1.5 text-xs focus:outline-none focus:border-red-400"
              />
            </div>
            <div className="flex gap-2">
              <div className="flex-1">
                <label className="block text-xs text-gray-500 mb-0.5">URL</label>
                <input
                  type="url"
                  value={article.href}
                  onChange={(e) => updateItem(i, { href: e.target.value })}
                  className="w-full border border-gray-200 rounded px-2 py-1.5 text-xs focus:outline-none focus:border-red-400"
                />
              </div>
              <div className="w-32">
                <label className="block text-xs text-gray-500 mb-0.5">日付</label>
                <input
                  type="text"
                  value={article.date}
                  onChange={(e) => updateItem(i, { date: e.target.value })}
                  className="w-full border border-gray-200 rounded px-2 py-1.5 text-xs focus:outline-none focus:border-red-400"
                  placeholder="2026.01.01"
                />
              </div>
            </div>
            <div>
              <ImageUploadField
                label="サムネイル（URLまたはアップロード）"
                value={article.img}
                onChange={(url) => updateItem(i, { img: url })}
                placeholder="https://example.com/thumb.jpg"
                previewClassName="h-20 w-full object-cover rounded-md"
              />
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={addItem}
        className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-2 border border-dashed border-red-400 rounded-lg text-sm text-red-600 hover:bg-red-50 cursor-pointer"
      >
        <i className="ri-add-line" /> 記事を追加
      </button>
    </div>
  );
}
